import React from 'react';
import { Card, Badge, Button, Tooltip, Empty, Tag, Space, Progress } from 'antd';
import { CheckCircleTwoTone, CloseCircleTwoTone, InfoCircleOutlined } from '@ant-design/icons';

const entityColors = {
  INVOICE: 'blue',
  REIMBURSEMENT: 'purple',
};

const MatchSuggestionPanel = ({ suggestions, onAccept, onReject }) => {
  if (!suggestions || suggestions.length === 0) {
    return <Empty description="No match suggestions found" style={{ margin: '32px 0' }} />;
  }
  return (
    <div style={{ marginBottom: 16 }}>
      <Card title={<span><InfoCircleOutlined /> Match Suggestions</span>} bordered={false}>
        <Space direction="vertical" style={{ width: '100%' }} size="middle">
          {suggestions.map(sug => (
            <Card
              key={sug.id}
              type="inner"
              style={{ background: '#fafcff', borderRadius: 8, border: '1px solid #e6f7ff' }}
              bodyStyle={{ padding: 16 }}
              title={<>
                <Tag color={entityColors[sug.entityType] || 'default'}>{sug.entityType}</Tag>
                <span style={{ marginLeft: 8, fontWeight: 500 }}>{sug.entityId}</span>
              </>}
              extra={null}
            >
              <div style={{ marginBottom: 8 }}>
                {sug.entityType === 'INVOICE' && sug.data && (
                  <>
                    <div><b>Invoice #:</b> {sug.data.invoiceOrQuoteNumber}</div>
                    <div><b>Amount:</b> {sug.data.total || sug.data.grandTotal}</div>
                    <div><b>Description:</b> {sug.data.description}</div>
                  </>
                )}
                {sug.entityType === 'REIMBURSEMENT' && sug.data && (
                  <>
                    <div><b>Expense #:</b> {sug.data.referenceNumber || sug.data.reimbursementNumber}</div>
                    <div><b>Amount:</b> {sug.data.claimedAmount || sug.data.amount}</div>
                    <div><b>Description:</b> {sug.data.description}</div>
                  </>
                )}
              </div>
              <div style={{ marginBottom: 8 }}>
                <span style={{ color: '#888' }}>Reason:</span> <span>{sug.matchReason}</span>
              </div>
              <Space>
                <Tooltip title="Accept and mark as paid">
                  <Button
                    type="primary"
                    icon={<CheckCircleTwoTone twoToneColor="#52c41a" />}
                    onClick={() => onAccept(sug)}
                    style={{ borderRadius: 20 }}
                    size="small"
                    animation="pulse"
                  >Accept</Button>
                </Tooltip>
                <Tooltip title="Reject this suggestion">
                  <Button
                    danger
                    icon={<CloseCircleTwoTone twoToneColor="#ff4d4f" />}
                    onClick={() => onReject(sug)}
                    style={{ borderRadius: 20 }}
                    size="small"
                  >Reject</Button>
                </Tooltip>
              </Space>
            </Card>
          ))}
        </Space>
      </Card>
    </div>
  );
};

export default MatchSuggestionPanel;
